export interface Recipe {
  RecipeId?: number | null;
  RecipeName: string;
  ChargeNumber?: number | null;
  CreationTimestamp?: string | null;
  UpdateTimestamp?: string | null;
  Author?: string | null;
  Comments?: string | null;
  IsEnable: boolean;
  IsActive: boolean;
  IsDuplicate?: boolean;
  TotalWeight?: number;
  OriginalRecipeId?: number | null;
  IsCurrent?: boolean;
  IsUsed?: boolean;
  Version?: number;
}

export const RECIPE_INITIAL_VALUES: Recipe = {
  RecipeId: null,
  RecipeName: "",
  CreationTimestamp: null,
  UpdateTimestamp: null,
  Author: "",
  Comments: "",
  IsEnable: false,
  IsActive: true,
  IsDuplicate: false,
  TotalWeight: 0,
  OriginalRecipeId: null,
  IsCurrent: true,
  IsUsed: false,
  Version: 1,
};
